/*
  Текст бейджа на шапке тарифа.

  Основной источник — поле stock («Акция / спецпредложение» в админке).
  Непустое значение всегда побеждает, и это единственный способ поставить
  бейдж любому тарифу без правок кода.

  Запасной вариант. Пока stock не заполнен ни у одного тарифа, «Тамошо Pro»
  и «Тамошо Pro Max» остаются с «Новый» — так было до перехода на данные.
  Это именно фолбек: как только в админке у тарифа появится stock, покажется
  он, а не «Новый». Когда поле заполнят у обоих — весь блок ниже можно
  удалить вместе с этим комментарием.
*/
const FALLBACK_NEW = /тамошо\s*pro/i;

export const tarifBadgeText = (raw) => {
  const stock = String(raw?.stock || "").trim();
  if (stock) return stock;
  return FALLBACK_NEW.test(String(raw?.name || "")) ? "Новый" : "";
};

export default tarifBadgeText;
